import type { FriendWhere } from '@pixelworld/shared';

/** What the friends list offers for a friend: go straight in, knock, or nothing. */
export type FriendAction = 'goTo' | 'knock' | null;

export function friendAction(where: FriendWhere): FriendAction {
  if (where.status !== 'playing') return null;
  return where.visibility === 'public' ? 'goTo' : 'knock';
}

/** Friends who play first, then those on the start page, then the rest; by name within each. */
export function friendOrder(where: FriendWhere): number {
  return { playing: 0, start: 1, offline: 2 }[where.status];
}

/** The page that takes the player to a friend's room (ADR 0019). */
export const friendUrl = (gameId: string, friendId: string) =>
  `/play/${encodeURIComponent(gameId)}?friend=${encodeURIComponent(friendId)}`;
